import { createApp } from 'vue';
import App from './App.vue';
import './style.css';

/**
 * 剑网3 武学研习奇穴推荐收集表 - 入口文件
 * @description Vue 3 应用入口
 */

const app = createApp(App);
app.mount('#app');
